import $ from 'jquery'

const Cookies = (($) => {

	class Cookies {

		constructor(){

		}

		get(cname){
			let i = 0,
				name = cname + "=",
				cookie = null,
				decodedCookie = decodeURIComponent(document.cookie),
				cookieList = decodedCookie.split(';')

			for(i = 0; i < cookieList.length; i++){
				let cookie = cookieList[i]

				while(cookie.charAt(0) == ' '){
					cookie = cookie.substring(1)
				}

				if(cookie.indexOf(name) == 0){
					return cookie.substring(name.length, cookie.length)
				}
			}

			return null
		}

		set(name, value, expirationDays){
			let expirationDate = new Date(),
				expires = ""

			if(!expirationDays){
				expirationDays = 30
			}

			expirationDate.setTime(expirationDate.getTime() + (expirationDays*24*60*60*1000))

			expires = "expires=" + expirationDate.toUTCString()

			document.cookie = name + "=" + value + ";" + expires + ";path=/";
		}


	}

	return new Cookies()
})($)

export default Cookies
